/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { CardContent, makeStyles, Typography } from "@material-ui/core";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { ENDPOINTS } from "../../../utility/Endpoints";

const useStyles = makeStyles({
	pre: {
		"& span": {
			whiteSpace: "pre-line",
		},
	},
});

/**
 * Renders script tags to be used for embedding web chat on custom pages
 * @param {string} selectedConfigId the id of the selected web chat configuration
 */
export const ScriptTags = ({ selectedConfigId }) => {
	const classes = useStyles();
	return (
		<CardContent>
			<Typography>
				To use the PACE web chat module on your webpage simply copy these two elements to your HTML page. Place the div
				in the body tag, and the script somewhere below the div, preferably near the end of the body tag.
			</Typography>
			<h5 style={{ margin: "25px 0" }}>Script Tag</h5>
			<SyntaxHighlighter
				className={classes.pre}
				language="javascript"
				style={docco}
				data-test-id="webchat-config-script-tag-wrapper"
			>
				{`<script
id="paceChatModule"
src="${ENDPOINTS.WEB_CHAT_CF}/pace-chatcomponent.min.js?configId=${selectedConfigId}&configEndpoint=${ENDPOINTS.ADMIN_API}">
</script>`}
			</SyntaxHighlighter>

			<h5 style={{ margin: "25px 0" }}>Body Element Tag</h5>
			<SyntaxHighlighter language="javascript" style={docco}>
				{`<div id="pace-webchat-root"></div>`}
			</SyntaxHighlighter>
		</CardContent>
	);
};
